import React from 'react';
import PropTypes from 'prop-types';
import './_SVGStore.scss';

/**
 * An SVG store component which contains svg files as symbols with IDs. This component is used together with SvgIcon which
 * references an svg from the store.
 */
export default function SVGStore(props) {
  const symbols = [];
  const defs = [];

  Object.keys(props.svgs).forEach(svg => {
    typeof props.svgs[svg] === 'function' && symbols.push(props.svgs[svg]().symbol);
    typeof props.svgs[svg] === 'function' && defs.push(...props.svgs[svg]().defs);
  });

  /*eslint-disable */
  const svgStoreProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    dangerouslySetInnerHTML: {
      __html: `<defs>${defs.join('')}</defs>${symbols.join('')}`
    }
  };

  return (
    <div className="SVGStore">
      <svg {...svgStoreProps} />
    </div>
  );
  /*eslint-enable */
}

SVGStore.propTypes = {
  /**
   * An object that contains SVGs
   * Each key is a function that returns an object.
   * That object has a `symbol`, which is a string representing the svg.
   * And a `defs` array, which contains an array of strings, each one is a definition of something used by `symbol`
   */
  svgs: PropTypes.objectOf(PropTypes.func).isRequired
};
